import {
    afterNextRender,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    signal,
    viewChild,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'ui-m000-c050-video',
    templateUrl: './m000-c050-video.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M000C050VideoComponent {
    videoUrl = input.required<string>();
    video = viewChild.required<ElementRef<HTMLVideoElement>>('video');

    isPlaying = signal(true);

    constructor() {
        afterNextRender(() => {
            const video = this.video().nativeElement;

            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;

            video.play().catch(() => {
                this.isPlaying.set(false);
            });
        });
    }

    togglePlay(video: HTMLVideoElement) {
        if (video.paused) {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;

            video
                .play()
                .then(() => {
                    this.isPlaying.set(true);
                })
                .catch(() => {
                    this.isPlaying.set(false);
                });
        } else {
            video.pause();
            this.isPlaying.set(false);
        }
    }
}
